import { render, staticRenderFns } from "./Coordinates.vue?vue&type=template&id=9a3d3aac"
import script from "./Coordinates.vue?vue&type=script&lang=js"
export * from "./Coordinates.vue?vue&type=script&lang=js"
import style0 from "./Coordinates.vue?vue&type=style&index=0&id=9a3d3aac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports